module.exports = __webpack_public_path__ + "static/Gallery-9-c3648009cbcb6ab27147adacb05dfdf1.jpg";